import { memo } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import PropTypes from "prop-types";
import { brandPropTypes } from "app/utils/propTypes";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { useLocation } from "react-router-dom";
import Paragraphs from "app/pages/.shared/Paragraphs";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import IconAwesomeLock from "app/pages/.shared/IconAwesomeLock";
import { BRANDS_WITH_ACCESS_TO_MY_BOOKING } from "app/constants";
import { sendTagOnMenuGoToAuth } from "app/utils/analytics";
import AccountMenuFooterContainer from "app/pages/Header/AccountMenu/AccountMenuFooter/AccountMenuFooterContainer";
import Button, { BUTTON_ICON_ALIGNMENTS } from "app/pages/.shared/form/Button";
import "./AccountMenuUnauthenticated.scss";

const AccountMenuUnauthenticated = ({
	brand,
	onItemClick = () => {},
	menuConnectMessages = [],
}) => {
	const { pathname, search } = useLocation();

	const onauthsuccessUrl = encodeURIComponent(`${pathname}${search}`);

	const marketingMessageNode =
		menuConnectMessages?.length > 0 ? (
			<div className="signup-menu-account__dynamic-message">
				<Paragraphs paragraphs={menuConnectMessages} enableHTMLFormatting />
				<Button
					to={{
						pathname: "/booking-auth",
						search: `?onauthsuccess=${onauthsuccessUrl}`,
					}}
					data-testid="go-to-booking-auth-link"
					onClick={() => {
						sendTagOnMenuGoToAuth();
						onItemClick();
					}}
					className="signup-menu-account__signup-login-link"
					label={<FormattedMessage id="menu.mobile.register.login" />}
					icon={<IconRight />}
					alignIcon={BUTTON_ICON_ALIGNMENTS.RIGHT}
				/>
			</div>
		) : (
			<div className="signup-menu-account__signup-intro">
				<IconAwesomeLock height={20} width={20} />
				<FormattedMessage id="menu.mobile.signup.to.flashsales.intro" tagName="h4" />
			</div>
		);

	const hideMarketingMessageNode = BRANDS_WITH_ACCESS_TO_MY_BOOKING.includes(brand);

	return (
		<div
			className="account-menu__modal account-menu--unauthenticated"
			data-testid="account-menu-unauthenticated"
		>
			{!hideMarketingMessageNode && marketingMessageNode}
			<nav
				className={classNames({
					"account-menu__body": true,
					"signup-menu-account__body--without-marketing-msg": hideMarketingMessageNode,
				})}
			>
				<ul className="signup-menu-account__nav">
					{!menuConnectMessages && !hideMarketingMessageNode && (
						<li className="signup-menu-account__nav-item">
							<RelativeLink
								to={{
									pathname: "/booking-auth",
									search: `?onauthsuccess=${onauthsuccessUrl}`,
								}}
								data-testid="go-to-booking-auth-link"
								onClick={() => {
									sendTagOnMenuGoToAuth();
									onItemClick();
								}}
							>
								<FormattedMessage id="menu.mobile.login.signup" tagName="h4" />
							</RelativeLink>
						</li>
					)}
					<AccountMenuFooterContainer onItemClick={onItemClick} isAuthenticated={false} />
				</ul>
			</nav>
		</div>
	);
};

AccountMenuUnauthenticated.propTypes = {
	brand: brandPropTypes,
	onItemClick: PropTypes.func,
	menuConnectMessages: PropTypes.array,
};

export default memo(AccountMenuUnauthenticated);
